import React from 'react';
import { Button, Input, Typography } from '@attentive-platform/stem-ui';

const IncreaseFreeTrial = ({ numberOfDays, setNumberOfDays }) => {
  const handleDecrement = () => {
    const currentValue = parseInt(numberOfDays) || 1;
    if (currentValue > 1) {
      setNumberOfDays(String(currentValue - 1));
    }
  };

  const handleIncrement = () => {
    const currentValue = parseInt(numberOfDays) || 1;
    if (currentValue < 42) {
      setNumberOfDays(String(currentValue + 1));
    }
  };

  return (
    <div className='mb-3 flex justify-between items-center'>
      <Typography variant='body3'>Free trial days</Typography>
      <div className='flex items-center [&_.MuiOutlinedInput-root]:rounded-none [&_.MuiOutlinedInput-notchedOutline]:rounded-none'>
        <Button
          variant='contained'
          color='primary'
          onClick={handleDecrement}
          className='text-2xl min-w-0 rounded-s-2xl'>
          −
        </Button>
        <Input
          type='number'
          value={numberOfDays}
          onChange={e => setNumberOfDays(e.target.value)}
          className='w-20 text-start'
          inputProps={{ min: 1, max: 42 }}
          required
        />
        <Button
          variant='contained'
          color='primary'
          onClick={handleIncrement}
          className='text-2xl min-w-0 rounded-e-2xl'>
          +
        </Button>
      </div>
    </div>
  );
};

export default IncreaseFreeTrial;
